<template lang="pug">
  .cart-button
    p.btn
      a(v-bind:href="buildUrl('cart/')") カート
    p.num(v-if="itemCount") {{ itemCount }}
</template>

<script>
import CustomerStore from '../../../stores/CustomerStore'
import config from '../../../components/config/Config'

export default {
  name: 'CartButton',
  mixins: [config],
  /**
   * data
   * @returns {{msg: string}}
   */
  data () {
    return {
    }
  },
  /**
   * mounted
   */
  mounted () {
  },
  computed: {
    /**
     * カートに入れている商品数を返す
     * @return number カートの商品数
     */
    itemCount () {
      return CustomerStore.state.user.itemCount
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .cart-button{
    float: left;
    width: 55px;
    padding-top: 25px;
    position: relative;
    a{
      display: block;
      background-image: url("../../../../static/images/pc/header/cart_off.png?v=1");
      background-repeat: no-repeat;
      width:45px;
      height:43px;
      text-indent: -10000px;
    }
    a:hover{
      background-image: url("../../../../static/images/pc/header/cart_on.png?v=1");
    }
    .num{
      position: absolute;
      display: inline-block;
      min-width: 10px;
      padding: 0 5px;
      text-align: center;
      font-size: 8px;
      background-color: #f35c42;
      height: 20px;
      line-height: 20px;
      color: #fff;
      border-radius: 10px;
      top: 17px;
      right:0;

    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pc/common/CartButton.vue